import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Box,
  Tooltip,
} from "@mui/material";
import {
  Menu,
  ChevronLeft,
  Notifications,
  People,
  Article,
  ExitToApp,
  Person,
  EventNote,
  Home,
} from "@mui/icons-material";

import Header from "../Component/Header";
import "../Css/Header.css";

const Dashboard = () => {
  const [open, setOpen] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleDrawer = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleNavigation = (path) => {
    navigate(path);
    toggleDrawer();
  };

  const menuItems = [
    { text: "Header", icon: <Home />, path: "/dashboard" },
    { text: "Manavseva", icon: <People />, path: "/manavseva" },
    { text: "Mochitimes", icon: <EventNote />, path: "/mochitimes" },
    { text: "News Letter", icon: <Article />, path: "/newsletter" },
    { text: "Notification", icon: <Notifications />, path: "/notifications" },
    { text: "User Log", icon: <Person />, path: "/userlog" },
    { text: "Logout", icon: <ExitToApp />, path: "/logout" },
  ];

  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      {/* Sidebar Drawer */}
      <Drawer
        variant="permanent"
        sx={{
          width: open ? 200 : 80,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: open ? 200 : 80,
            transition: "width 0.3s ease-in-out",
            overflowX: "hidden",
            backgroundColor: "#0A3161",
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingY: 2,
          },
        }}
      >
        {/* Toggle Button */}
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: open ? "flex-end" : "center",
            paddingX: 1,
          }}
        >
          <IconButton onClick={toggleDrawer} sx={{ color: "#FFD700" }}>
            {open ? <ChevronLeft /> : <Menu />}
          </IconButton>
        </Box>
        <p className="p1  d-flex justify-content-center">GKA Admin Panel</p>
        {/* Menu Items */}
        <List sx={{ width: "100%" }}>
          {menuItems.map((item, index) => (
            <Tooltip
              title={!open ? item.text : ""}
              placement="right"
              key={index}
            >
              <ListItem
                button
                onClick={() => handleNavigation(item.path)}
                sx={{
                  display: "flex",
                  cursor: "pointer",
                  justifyContent: open ? "flex-start" : "center",
                  paddingY: 1.5,
                  paddingX: open ? 2 : 1,
                  transition: "background 0.3s ease-in-out",
                  "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.2)" },
                }}
              >
                <ListItemIcon
                  sx={{
                    color: item.color || "#FFD700",
                    minWidth: "auto",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                {open && (
                  <ListItemText
                    primary={item.text}
                    sx={{ color: "#fff", marginLeft: 1 }}
                  />
                )}
              </ListItem>
            </Tooltip>
          ))}
        </List>
      </Drawer>

      {/* Show Header Only on Dashboard */}
      {location.pathname === "/dashboard" && <Header />}
    </Box>
  );
};

export default Dashboard;
